export enum AppRoute {
  Admin = 'admin',
  Companies = 'companies',
  Treasury = 'treasury',
  Portfolio = 'portfolio',
  Funds = 'funds',
  Unauthorized = 'unauthorized',
  User = 'user',
  ReleaseNotes = 'releasenotes',
  Documents = 'documents',
  Notification = 'notifications',
  Dashboard = 'dashboard',
  Review = 'review',
  QuarterlyResults = 'quarterly-results',
  Summary = 'summary',
  Status = 'status',
  Overview = 'overview',
  Tearsheets = 'tearsheets',
  Valuation = 'valuation',
  CommitmentOverview = 'commitment-overview',
  Contacts = 'contacts',
  TearsheetPackage = 'tearsheet-package',
  Staffing = 'staffing',
  List = 'list',
  Editor = 'editor',
  Users = 'users',
  SystemProperties = 'system-properties',
  Document = 'document',
  GenerateWorkflow = 'generate-workflow',
  Reconciliation = 'reconciliation',
  ActivityLogs = 'activity-logs',
  AlertsWorkflow = 'alerts-workflow',
  Report= 'report',
  CompanyReport= 'company-report',
  Commitment= 'commitment',
  DistributionNew= 'distribution/new',
  Contribution= 'contribution',
  Distribution= 'distribution',
  NewInputs= 'newInputs',
  Performance= 'performance',
  Tearsheet= 'tearsheet',
  Assets= 'assets',
  Attachments= 'attachments',
  Forecast= 'forecast',
  Variance= 'variance',
  Accomplishments= 'accomplishments',
  Focus= 'focus',
  Future= 'future',
  AdvanceForm= 'advance-form',
  PowerbiReport = 'powerbi-report',
  Download= 'download',
  FundFlow= 'fund-flow-diagram',
  PcAnalytics = 'pc-analytics'
}
